import axios from 'axios';
import { mapObjIndexed, filter, path } from 'ramda';

import { OBJ_TYPE } from 'constants/metro';
import { mapIndexed } from 'utils/ramdaAdditions';

import * as urls from 'constants/urls';

export const postMetroRequestDocumentHandler = ({ payload: { id, authKey, documentsUpload = [] } }) =>
    Array.isArray(documentsUpload) ? axios.fullAll(
        filter(d => !d.id, documentsUpload).map(
            doc => axios.post(urls.METRO_DOCUMENT.stringify(), ({
                ...doc,
                fileExt: doc.fileType,
                docType: doc.documentType,
                docTypeInt: 0,
            }), {
                params: {
                    id,
                    objtype: OBJ_TYPE,
                    authKey,
                }
            })
        )
    ).catch(({ errors }) =>
        Promise.reject({ objkey: id, documentErrors: errors, translate: 'errors.saveDocumentError', })
    ) : Promise.reject();

export const postMetroRequestHandler = ({ payload: { id, authKey, documentsUpload = [], ...data }}) =>
    id ? (
        postMetroRequestDocumentHandler({ payload: { id, authKey, documentsUpload } })
            .then(() => axios.post(urls.METRO_REQUEST.stringify({ id }), data, { params: { authKey } }))
    ) : (
        axios.post(urls.METRO_REQUEST.stringify({ id }), data, { params: { authKey } })
            .then(({ objkey }) =>
                postMetroRequestDocumentHandler({ payload: { id: objkey, authKey, documentsUpload } })
                    .then(() => ({ objkey }))
            )
    );

export const postMetroRequestRouteHandler = ({ payload: { objkey, ...data }}) => {
    const approval_route = [];

    mapObjIndexed(item => {
        if (item.id) {
            approval_route.push({
                id: item.id,
                peopleId: item.required ? 0 : item.peopleId,
                excluded: Number(!item.notExcluded),
            });
        }
    }, data.routes || []);

    return (
        axios.post(
            urls.METRO_REQUEST_ROUTE.stringify(),
            { createRoute: data.createRoute, approval_route },
            { params: { objkey } }
        )
    );
};
export const getMetroRequestsHandler = ({ payload }) => axios.get(urls.METRO_REQUEST.stringify(), { params: payload });
export const getMetroRequestHandler = ({ payload: { id, ...params } }) => axios.get(urls.METRO_REQUEST.stringify({ id }), { params });
export const getMetroPositionHandler = ({ payload }) => (
    payload.positionCode
        ? axios.get(urls.METRO_POSITION_DESCRIPTION.stringify({ id: payload.positionCode }), { params: { addstr: payload.city, addstr1: payload.routeType } })
        : axios.get(urls.METRO_POSITION.stringify(), { params: { cellID: payload.id, addstr: payload.city, addstr1: payload.routeType } })
);
export const getMetroChiefHandler = ({ payload: { id, type, replace } }) => axios.get(urls.METRO_CHIEF.stringify(), { params: { department: id, replace, type } });
export const getMetroCostHandler = ({ payload }) => (
    axios.get(urls.METRO_COST.stringify(), { params: payload })
);
export const getMetroFunctionHandler = ({ payload }) => (
    axios.get(urls.METRO_FUNCTION.stringify(), { params: payload })
);

export const postMetroRequestApprovalHandler = ({ payload: { ids, title, comment, params } }) => {
    return axios.all(
        mapIndexed((id, index) => axios.post(urls.CREATE_METRO_REQUEST_APPROVAL.stringify({ id }), {
            id: id,
            result: title,
            comment: comment,
        }, { params: { authKey: path([index, 'authKey'], params) } }), ids)
    );
};

export const getMetroAuthHandler = () => axios.get(urls.LOGIN.stringify({ type: 'sso' }));
export const getMetroRequestLinkHandler = ({ payload }) => axios.get(urls.METRO_AUTH.stringify(), { params: payload });

export const getMetroDocumentHandler = ({ payload = {} }) => axios.get(urls.DOCUMENT_METRO.stringify({
    id: payload.docKeyInAnketaData,
    place: payload.place || '3'
}), {
    params: { requestID: payload.metro }
});
